







import { Component, Vue } from 'vue-property-decorator';
import KeycloakStore from '@/stores/user/keycloak.store';
import { getModule } from 'vuex-module-decorators';
import UserStore from '@/stores/user/user.store';
import Routes from '@/util/Routes';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';

@Component({
  components: {LoadingIndicator},
})
export default class User extends Vue {
  private routes = Routes;
  private loading = true;
  public keycloakStore = getModule(KeycloakStore, this.$store);
  public userStore = getModule(UserStore, this.$store);

  public async mounted() {
    await this.keycloakStore.initialize();
    const user = await this.userStore.fetchUser();
    this.loading = false;
    if (!this.keycloakStore.authenticated) {
      return await this.$router.push({name: this.routes.Home});
    }
    if (user.success) {
      this.userStore.copyUserForEditing();
    }
  }

  get duringRegistration() {
    return this.$route.matched.some((record) => record.meta.isRegisterHeader);
  }
}
